<template>
  <div
    id="cart-clazz"
    class="c-cart js-cart c-cart--slider"
    v-bind:class="{'c-cart--open': cartOpen}"
  >
    <!-- cart -->

    <a id="cart-header" href v-on:click="closeCart($event)" class="c-cart__header">
      <span class="c-cart__headerText">Shopping Cart</span>
      <span class="c-cart__headerText">Close</span>
    </a>

    <ul class="c-cart__list">
      <li v-for="(ring, index) in cart" :key="ring.id" class="c-cart__item">
        <img
          class="c-cart__image"
          v-bind:src="ring.ring.variations[ring.ring.variationIndex].images[0].url"
        />
        <div class="c-cart__item-details c-cart__anim-1">
          <h2 class="c-cart__ringName">{{ ring.ring.name }}</h2>
          <p
            class="c-cart__detail"
          >Metal: {{ ring.ring.variations[ring.ring.variationIndex].variation_name }}</p>
          <span class="c-cart__detail">Size: {{ ring.selectedSize.text }}</span>
        </div>
        <div class="c-cart__item-details c-cart__anim-2 c-cart__item-details--al-m">
          <p
            class="c-cart__price"
          >{{ ring.ring.variations[ring.ring.variationIndex].price[$store.state.currency].formatted }}</p>
          <button v-on:click="removeFromCart(index)" class="c-cart__link">Remove</button>
        </div>
      </li>
      <p class="c-cart__note">
        Please Note:
        <span v-show="cart.length == 1">This item</span>
        <span v-show="cart.length > 1">These items</span> is made to order and will will be dispatched within 4 weeks.
      </p>
    </ul>

    <div class="c-cart__totals c-cart__anim-basic">
      <div class="c-cart__subTotal">
        <span class="c-cart__subTotal-total">TOTAL</span>
        <span class="c-cart__subTotal-currency">({{$store.state.currency}})</span>
        <span class="c-cart__subTotal-price">
          <span v-show="$store.state.currency != 'EUR' && $store.state.currency != 'GBP'">$</span>
          <span v-show="$store.state.currency == 'EUR'">€</span>
          <span v-show="$store.state.currency == 'GBP'">£</span>
          {{total}}
        </span>
      </div>

      <div class="c-field c-field--checkbox" v-bind:class="{'c-field--checkbox-spin':spinCheckbox}">
        <span
          class="c-field__error c-field__error--checkout"
          v-show="agreeToTermsError"
        >Please accept this term</span>
        <input
          class="c-field__input--checkbox"
          type="checkbox"
          name="AgreeToTerms"
          id="agreeToTerms"
          v-model="agreeToTerms"
        />
        <label
          for="agreeToTerms"
          class="c-field__label c-field__label--checkbox"
        >I accept all terms and conditions</label>
      </div>
      <!-- TODO ONLY SHOW THE LINE BELOW IF NZ OR GBR -->
      <small class="c-cart__legals">All items are shipped from New Zealand.</small>
      <a v-on:click="orderItem($event)" href class="c-cart__checkout c-btn c-btn--block">CHECKOUT</a>
      <a
        id="go-back"
        href
        class="c-btn c-btn__link c-cart__anim-basic"
        style="right:0;"
        v-on:click="closeCart($event)"
      >Continue shopping</a>
    </div>
  </div>
</template>

<script>
import store from "../main.js";
import { mapGetters } from "vuex";

export default {
  name: "Cart",
  data: function () {
    return {
      itemsInCart: false,
      cartOpen: false,
      cartLength: 0,
      agreeToTerms: false,
      spinCheckbox: false,
      agreeToTermsError: false,
      total: 0,
    };
  },
  props: ["cart"],
  watch: {
    agreeToTerms: function (newVal) {
      this.agreeToTermsError = !newVal;
    },
    cart: function (newVal, oldVal) {
      var self = this;

      self.itemsInCart = newVal.length > 0 ? true : false;

      if (newVal.length > self.cartLength) {
        self.cartOpen = true;
        if (window.matchMedia("(max-width:765px)").matches) {
          this.scrollToCartTop();
        } else {
          this.scrollToCartBottom();
        }
        self.$parent.calcCartHeight(true);
        self.animateCart();
      }
      self.cartLength = newVal.length;
      if (self.cartLength == 0) {
        self.cartOpen = false;
        self.$parent.calcCartHeight(false);
      }
      var tempTotal = 0;
      self.cart.forEach(function (item) {
        tempTotal +=
          item.ring.variations[item.ring.variationIndex].price[
            self.$store.state.currency
          ].amount;
      });

      var current = { count: self.total };

      if (oldVal.length == 0) {
        setTimeout(function () {
          TweenMax.to(current, 0.6, {
            count: tempTotal,
            onUpdate: function () {
              // console.log(current.count);
              self.total = (current.count / 100).toFixed(2);
            },
          });
        }, 900);
      } else {
        TweenMax.to(current, 0.6, {
          count: tempTotal,
          onUpdate: function () {
            // console.log(current.count);
            self.total = (current.count / 100).toFixed(2);
          },
        });
      }
    },
    immediate: true,
  },
  methods: {
    orderItem: function (event) {
      var self = this;
      event.preventDefault();
      if (self.agreeToTerms) {
        self.$parent.calcCartHeight(false);
        this.$parent.openOrderForm();
      } else {
        self.agreeToTermsError = true;
        self.spinCheckbox = true;
        setTimeout(function () {
          self.spinCheckbox = false;
        }, 500);
      }
    },
    resetAnimation: function () {
      TweenMax.to($(".c-cart__item"), 0.3, { width: "0%" });
      TweenMax.to($(".c-cart__image"), 0.3, { opacity: 0, x: -15 });
      TweenMax.to($(".c-cart__anim-1"), 0.3, { opacity: 0, x: 30 });
      TweenMax.to($(".c-cart__anim-2"), 0.3, { opacity: 0, x: 30 });
    },
    animateCart: function () {
      setTimeout(function () {
        TweenMax.fromTo(
          $(".c-cart__item"),
          0.5,
          { width: "0%" },
          { width: "100%", ease: Power1.easeOut }
        );

        setTimeout(function () {
          TweenMax.fromTo(
            $(".c-cart__image"),
            0.35,
            { opacity: 0, x: -15 },
            { opacity: 1, x: 0, ease: Power1.easeOut }
          );
        }, 130);

        setTimeout(function () {
          TweenMax.fromTo(
            $(".c-cart__anim-1"),
            0.5,
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, ease: Power1.easeOut }
          );
        }, 200);

        setTimeout(function () {
          TweenMax.fromTo(
            $(".c-cart__anim-2"),
            0.35,
            { opacity: 0, y: 30 },
            { opacity: 1, y: 0, ease: Power1.easeOut }
          );
        }, 500);
      }, 700);
    },
    toggleCart: function () {
      this.cartOpen = !this.cartOpen;

      if (this.cartOpen) {
        this.animateCart();
        if (window.matchMedia("(max-width:765px)").matches) {
          this.scrollToCartTop();
        } else {
          this.scrollToCartBottom();
        }
      } else {
        this.resetAnimation();
      }
    },
    scrollToCartTop: function () {
      $("html, body").animate(
        {
          scrollTop: $("#cart-header").offset().top,
        },
        500
      );
    },
    scrollToCartBottom: function () {
      $("#cart-clazz").animate(
        {
          scrollTop: $("#cart-clazz")[0].scrollHeight,
        },
        500
      );
    },
    removeFromCart: function (index) {
      this.$store.commit("removeFromCart", index);
    },
    openCart: function (event) {
      this.cartOpen = true;
      if (window.matchMedia("(max-width:765px)").matches) {
        this.scrollToCartTop();
      } else {
        this.scrollToCartBottom();
      }
      this.animateCart();
    },
    closeCart: function (event) {
      var self = this;
      self.$parent.calcCartHeight(false);
      event.preventDefault();
      this.cartOpen = false;
      this.resetAnimation();
    },
  },
  computed: {},
  created() {},
};
</script>


// WEBPACK FOOTER //
// Cart.vue?156a2b13